import { t } from 'i18next';
import { ROUTES } from 'vio-constants';
import { capitalize, isRoute } from 'vio-libs';
import { calculateLockerName } from '../lockers/lib';
export function useBreadCrumbs(location, context = {}) {
    const { pathname, search } = location;
    const { edgeOffering, kexProfile, locker, port, site } = context;
    const queryParams = new URLSearchParams(search);
    const organization = queryParams.get('organization');
    if (pathname === '/') {
        return [{
                link: undefined,
                text: ROUTES.HOME
            }];
    }
    const pathnameStr = pathname[0] === '/' ? pathname.slice(1) : pathname;
    const splitPathnames = pathnameStr.split('/');
    const breadcrumbs = [];
    for (let i = 0; i < splitPathnames.length; i += 1) {
        const pathname = splitPathnames[i];
        const upperCasePathname = pathname.toUpperCase();
        if (upperCasePathname in ROUTES) {
            const capitalizedPathname = upperCasePathname === t('KEX', {
                ns: 'Common'
            }) ? t('KEX', {
                ns: 'Common'
            }) : capitalize(pathname);
            if (ROUTES[upperCasePathname] === ROUTES.LOCATIONS) {
                breadcrumbs.push({
                    link: `${ROUTES.LOCATIONS}?organization=${organization}`,
                    text: t('LOCATIONS', {
                        ns: 'Common'
                    })
                });
                break;
            }
            else if (ROUTES[upperCasePathname] === ROUTES.PORT) {
                breadcrumbs.push({
                    link: ROUTES.NETWORKING,
                    text: t('NETWORKING_OVERVIEW', {
                        ns: 'Common'
                    })
                });
                break;
            }
            else if (ROUTES[upperCasePathname] === ROUTES.COMMUNITY) {
                breadcrumbs.push({
                    link: edgeOffering || kexProfile ? `${ROUTES.KEX}${ROUTES.COMMUNITY}?organization=${organization}` : undefined,
                    text: t('COMMUNITY', {
                        ns: 'Common'
                    })
                });
                break;
            }
            breadcrumbs.push({
                link: i === splitPathnames.length - 1 ? undefined : ROUTES[upperCasePathname],
                text: capitalizedPathname
            });
        }
    }
    if (site) {
        const { name, site_id, slug } = site;
        breadcrumbs.push({
            link: locker ? `${ROUTES.LOCATIONS}/${slug}?organization=${organization}` : undefined,
            text: `${site_id} ${name}`
        });
    }
    if (locker) {
        const { name: displayName, sku: lockerSKU } = locker;
        const lockerName = calculateLockerName(lockerSKU);
        breadcrumbs.push({
            link: undefined,
            text: `${displayName ? `${displayName} - ` : ''}${lockerName}`
        });
    }
    if (port) {
        const { description, name: deviceName } = port;
        breadcrumbs.push({
            link: undefined,
            text: description && description.length > 0 ? description : deviceName
        });
    }
    if (kexProfile) {
        const { id: profileId, name } = kexProfile;
        breadcrumbs.push({
            link: edgeOffering ? `${ROUTES.KEX}${ROUTES.COMMUNITY}?organization=${organization}&profile=${profileId}` : undefined,
            text: name
        });
    }
    if (edgeOffering && kexProfile) {
        const { name } = edgeOffering;
        breadcrumbs.push({
            link: undefined,
            text: name
        });
    }
    return breadcrumbs;
}
export function constructParamString(currentParams, incomingParams) {
    const incomingParamsKeys = Object.keys(incomingParams);
    const newParams = new URLSearchParams(currentParams);
    if (currentParams.length !== 0) {
        const parsedParams = new URLSearchParams(currentParams);
        const parsedParamsKeys = parsedParams.keys();
        for (const key of parsedParamsKeys) {
            if (incomingParamsKeys.indexOf(key) === -1) {
                if (parsedParams.get(key).length > 0) {
                    const value = parsedParams.get(key);
                    newParams.set(key, value);
                }
                else {
                    newParams.set(key, 'true');
                }
            }
        }
    }
    for (let i = 0; i < incomingParamsKeys.length; i += 1) {
        const key = incomingParamsKeys[i];
        const value = incomingParams[key];
        if (Array.isArray(value)) {
            newParams.set(key, `[${value}]`);
        }
        else if (typeof value === 'boolean') {
            if (value) {
                newParams.set(key, 'true');
            }
            else {
                newParams.delete(key);
            }
        }
        else if (typeof value !== 'boolean') {
            newParams.set(key, String(value));
        }
    }
    const newParamsString = newParams.toString();
    return newParamsString.length > 0 ? `?${newParamsString}` : '';
}
export function constructRackRoute(slug, rack) {
    const { LOCATION, RACKS } = ROUTES;
    return `${LOCATION}${RACKS}?slug=${slug}&rack=${rack}`;
}
export function isActiveConnectionsRoute(currentRoute) {
    return isRoute(currentRoute, `${ROUTES.KEX}${ROUTES.ACTIVE_CONNECTIONS}`);
}
export function isAuthRoute(currentRoute) {
    return isRoute(currentRoute, ROUTES.AUTH);
}
export function isLocationsRoute(currentRoute) {
    return isRoute(currentRoute, ROUTES.LOCATIONS);
}
export function isMapRoute(currentRoute) {
    return isRoute(currentRoute, ROUTES.MAP);
}
export function isUserRoute(currentRoute) {
    return isRoute(currentRoute, ROUTES.USERS);
}
